module.exports = __webpack_public_path__ + "static/img/分析报告_0.7b3eaa4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/分析报告_0.jpg
// module id = O5Aw
// module chunks = 1